import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/social-proof.css';

const badgeIcons = [
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
	<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
];

const badgeKeys = ['socialProof.badge1', 'socialProof.badge2', 'socialProof.badge3'];

const SocialProof = () => {
	const { t } = useTranslation();

	return (
		<section className="social-proof-section">
			<div className="container-modern">
				<div className="social-proof-bar">
					{badgeKeys.map((key, index) => (
						<React.Fragment key={index}>
							{index > 0 && <span className="badge-separator" aria-hidden="true" />}
							<div className="proof-badge">
								{badgeIcons[index]}
								<span>{t(key)}</span>
							</div>
						</React.Fragment>
					))}
				</div>
			</div>
		</section>
	);
};

export default SocialProof;
